import { chevronDown } from '@wordpress/icons';
import React from 'react';
import { Icon } from '../Icon';
import { Text } from '../Text';
import * as styles from './Select.styles';
var ArrowWrapperView = styles.ArrowWrapperView;

var SelectArrow = function () {
  return /*#__PURE__*/React.createElement(ArrowWrapperView, null, /*#__PURE__*/React.createElement(Text, {
    isBlock: true,
    variant: "muted"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: chevronDown,
    size: 16
  })));
};

export default /*#__PURE__*/React.memo(SelectArrow);